<template>
	<div v-if="isshowOutputDialog" style="width: 100%">
		<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
			</template>
			<template #actions></template>
			<el-form-item label="所属门店：">
				<el-select filterable v-model="formInline.belongStoreKeyId" placeholder="请选择门店" clearable size="small" @change="search()">
					<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="出库单号：">
				<el-input clearable v-model="formInline.outputStoreNo" size="small" placeholder="请输入出库单号" @keyup.enter.native="inputChange"></el-input>
			</el-form-item>
			<el-form-item label="出库时间：">
				<el-date-picker
					v-model="dateValue"
					clearable
					size="small"
					type="daterange"
					value-format="yyyy-MM-dd"
					format="yyyy-MM-dd"
					range-separator="~"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					@change="handleDateChange"
				></el-date-picker>
			</el-form-item>
			</lcsj-filter>
		<STable :columns="columnsData" :data="listData" :loading="loading" border @get-data="getListData">
			<el-table-column slot="customerInfo.gender" label="性别" width="100" align="center">
				<template #default="scope">
					{{ scope.row.customerInfo.gender === 1 ? "男" : "女" }}
				</template>
			</el-table-column>
			<template #price>
				<el-table-column v-if="canSeeCost" label="单价" min-width="100" align="center">
					<template #default="scope">
						<span style="color: #ff9900; font-weight: 600; white-space: nowrap" v-money="scope.row.price || 0">￥{{ Number(scope.row.price || 0).toFixed(2) }} 元</span>
					</template>
				</el-table-column>
			</template>
			<template #money>
				<el-table-column v-if="canSeeCost" label="金额" min-width="100" align="center">
					<template #default="scope">
						<span style="color: #ff9900; font-weight: 600; white-space: nowrap" v-money="scope.row.money || 0">￥{{ Number(scope.row.money || 0).toFixed(2) }} 元</span>
					</template>
				</el-table-column>
			</template>
		</STable>
		<!-- 分页组件 -->
		<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
	</div>
</template>

<script>
import costPermission from "@/utils/costPermission.js";
import { GetOutputStoreDtlPageList } from "@/api/receiptApi.js";
import { GetOrganizationListByConfig } from "@/api/organizationalApi.js";
export default {
	mixins: [costPermission],
	data() {
		return {
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			storeList: [],
			dateValue: [],
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				goodsKeyId: "",
				startTime: null,
				endTime: null,
				outputStoreNo: "",
				belongStoreKeyId: ""
			},
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "outputStoreNo",
					label: "出库单号",
					align: "center",
					isKeep: true,
					width: "230"
				},
				{
					prop: "outputDate",
					label: "出库日期",
					align: "center",
					isKeep: true,
					width: "180"
				},
				{
					prop: "belongStoreName",
					label: "所属门店",
					align: "center",
					isKeep: true,
					width: "150"
				},
				{
					prop: "outputStateStr",
					label: "出库类型",
					align: "center",
					isKeep: true,
					width: "120"
				},
				{
					prop: "jjInformation",
					label: "镜架信息",
					align: "center",
					minWidth: "120"
				},
				{
					prop: "machinTypeStr",
					label: "加工类型",
					align: "center",
					minWidth: "120"
				},
				{
					prop: "goodsInfo.type",
					label: "商品品牌",
					align: "center",
					isKeep: true,
					width: "120"
				},
				{
					prop: "goodsInfo.name",
					label: "商品名称",
					align: "center",
					width: "160"
				},
				{
					prop: "goodsInfo.qiuJing",
					label: "球镜",
					align: "center",
					width: "80"
				},
				{
					prop: "goodsInfo.zhuJing",
					label: "柱镜",
					align: "center",
					width: "80"
				},
				{
					slot: "price",
					label: "单价",
					align: "center",
					width: "80"
				},
				{
					prop: "quantity",
					label: "数量",
					align: "center",
					width: "80"
				},
				{
					slot: "money",
					label: "金额",
					align: "center",
					width: "100"
				},
				{
					prop: "remark",
					label: "备注",
					align: "center",
					minWidth: "180"
				},
				{
					prop: "customerInfo.name",
					label: "顾客姓名",
					align: "center",
					width: "80"
				},
				{
					slot: "customerInfo.gender",
					label: "顾客性别",
					align: "center",
					width: "80"
				},
				{
					prop: "customerInfo.age",
					label: "顾客年龄",
					align: "center",
					width: "80"
				},
				{
					prop: "creator",
					label: "创建人",
					align: "center",
					minWidth: "80"
				},
				{
					prop: "createTime",
					label: "创建时间",
					align: "center",
					minWidth: "160"
				},
				{
					prop: "editor",
					label: "维护人",
					align: "center",
					minWidth: "80"
				},
				{
					prop: "updateTime",
					label: "维护时间",
					align: "center",
					minWidth: "160"
				}
				// {
				//   operation: true,
				//   isKeep: true,
				//   label: "操作",
				//   btnGroup: [
				//     {
				//       icon: "el-icon-delete",
				//       name: "删除",
				//       type: "4",
				//       btnType: "danger",
				//     },
				//   ],
				// },
			],

			isshowOutputDialog: false
		};
	},
	// 注册组件
	components: {},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		showOutputDialog(keyId) {
			this.isshowOutputDialog = true;
			this.formInline.goodsKeyId = keyId;
			this.getListData();
			this.GetOrganizationListByConfig();
		},
		closeOutputDialog() {
			this.isshowOutputDialog = false;
			this.formInline.goodsKeyId = "";
		},
		changePages() {},
		handleDateChange(val) {
			if (val) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetOutputStoreDtlPageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.search();
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 获取所属门店
		GetOrganizationListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrganizationListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		}
	}
};
</script>

<style scoped></style>
